export default "__VITE_ASSET__BOk825Hi__"